import React from "react";
import Header from "../Header/Header";
import "./Hero.css";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
import { Link } from "react-scroll";

//Images
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  const handleCallBtn = () => {
    window.location.href = "tel:+60182425832";
  };
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />

        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? "168px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>The best translator in town</span>
        </div>

        <div className="hero-text">
          <div>
            <span className="stroke-text">Localization</span>
            <span> with</span>
          </div>
          <div>
            <span>a</span>
            <span className="stroke-text"> Twist</span>
          </div>
          <div>
            <span>Where langugae meets adventure!</span>
          </div>
        </div>

        <div className="figures">
          <div>
            <span>
              <NumberCounter end={30} start={0} delay="2" preFix="+" />
            </span>
            <span>expert translators</span>
          </div>
          <div>
            <span>
              <NumberCounter end={200} start={50} delay="2" preFix="+" />
            </span>
            <span>past clients</span>
          </div>
          <div>
            <span>
              <NumberCounter end={4} start={0} delay="1" preFix="+" />
            </span>
            <span>services we provide</span>
          </div>
        </div>

        <div className="hero-buttons">
          <Link className="btn" to="join-us" span={true} smooth={true}>
            Contact Us
          </Link>
          <Link className="btn" to="services" span={true} smooth={true}>
            Learn More
          </Link>
        </div>
      </div>
      <div className="right-h">
        <button className="btn" onClick={handleCallBtn}>
          Call Us Now
        </button>

        <img
          src={hero_image}
          alt="Person tying his shoe"
          className="hero-image"
        />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "30rem" }}
          transition={transition}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />
      </div>
    </div>
  );
};

export default Hero;
